module.exports = __webpack_public_path__ + "img/game13.36db33ec.png";